import { connect } from 'react-redux';
import { compose } from 'redux';
import createLessonContentSelectors from 'edrolo/selectors/bound/createLessonContentSelectors';
import lessonLoader from './lessonLoader';
import classDetailLoader from './classDetailLoader';
import classLessonProgressLoader from './classLessonProgressLoader';
import ClassStudentLessonProgress from './ClassStudentLessonProgress';
import { getClassLessonGridData, getBreadcrumbs } from './selectors';
import { COURSE_FEATURES } from 'core/constants';

const mapStateToProps = (state, ownProps) => {
  const lessonId = ownProps.match.params.lessonId;
  const classId = ownProps.match.params.classId;

  const lessonContentSelectors = createLessonContentSelectors(lessonId);

  return {
    classId,
    totalQuizMarks: lessonContentSelectors.getTotalLessonQuizMarks(state),
    classLessonData: getClassLessonGridData(state, ownProps),
    breadcrumbs: getBreadcrumbs(state, ownProps),
    showStudentNotes: state.class
      ?.getIn(['classDetail', `${classId}`, 'features'])
      ?.contains(COURSE_FEATURES.STUDENT_NOTES),
  };
};

export default compose(
  classDetailLoader,
  lessonLoader,
  classLessonProgressLoader,
  connect(mapStateToProps)
)(ClassStudentLessonProgress);
